import { ChangeEvent, useRef } from 'react';
import { showAppNotification } from '@rainbow-modules/app';
import Button from 'components/Button';
import parseIcsHolidays, { CalendarHoliday } from './parseIcsHolidays';
import withoutExistingDates from './withoutExistingDates';
import { HiddenFileInput } from './styled';

interface HolidayImportButtonProps {
    value?: CalendarHoliday[];
    onChange?: (value: CalendarHoliday[]) => void;
}

const HolidayImportButton = ({
    value = [],
    onChange = () => {},
}: HolidayImportButtonProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleImport = async (event: ChangeEvent<HTMLInputElement>) => {
        const fileInput = event.target;
        const [file] = Array.from(fileInput.files || []);
        fileInput.value = '';
        if (!file) return;

        const { holidays: imported, skipped } = parseIcsHolidays(await file.text());
        onChange([...value, ...withoutExistingDates(value, imported)]);
        if (skipped > 0) {
            showAppNotification({
                title: 'Some holidays were not imported',
                description: `${skipped} event${skipped === 1 ? '' : 's'} could not be imported.`,
                icon: 'warning',
                timeout: 5000,
            });
        }
    };

    return (
        <>
            <Button
                label="Import .ics"
                variant="outline-brand"
                size="small"
                borderRadius="semi-rounded"
                onClick={() => fileInputRef.current?.click()}
            />
            <HiddenFileInput
                ref={fileInputRef}
                type="file"
                accept=".ics,text/calendar"
                onChange={handleImport}
            />
        </>
    );
};

export default HolidayImportButton;
